import { messageCls } from './styles.js';
import { jsx } from 'react/jsx-runtime';

function EmptyMessage({
  message,
  ref
}) {
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    className: messageCls,
    children: message ?? "Du har ingen nye notifikationer"
  });
}

export { EmptyMessage };
//# sourceMappingURL=EmptyMessage.js.map
